/* eslint-disable max-len */
// /* eslint-disable security/detect-object-injection */
import React from 'react'
import { useEffect, useCallback, useContext, useState } from "react"
import { useDispatch, useSelector } from 'react-redux'
import { Link, useLocation, useSearchParams } from 'react-router-dom'
import TopHeader from '../../../../components/TopHeader'
import GlobalContext from '../../../../components/Context/GloablContext'
import Emptyscreen from '../../../../components/EmptyScreen'
import Pagination from '../../../../components/Pagination'
import Debounce from '../../../../CommonMethods/Debounce'
import Limit from '../../../../components/Limit'
import CustomOverLay from '../../../../components/CustomOverLay'
import { handleAddFilterValues, handleIsViewScreen, handleSystemConfig, resetFilterState } from '../../../../redux/systemConfigSlice'
import moment from 'moment'
import SearchEmptyScreen from '../../../../components/SearchEmptyScreen'
import ObserverActivityHistoryTopBar from './Component/Topbar/Index'
import ObserverActivityTable from './Component/Table/Index'
import { useExportObserverActivityHistoryMutation, useObserverActivityHistoryListQuery } from '../../../../slices/observerSlice'
import HelpGuideModal from '../../../../components/HelpGuideModal'
import {useGetHelpGuideOrganizationQuery} from '../../../../slices/patientSlice'
import { dataService } from '../../../../services/data.services'

export default function ManageObserverActivityHistory() {

    const { setToastmessage, Toastmessage, toastErrorMessage, setToastErrorMessage, isSideBar } = useContext(GlobalContext);
    const [limit, setLimit] = useState("15")
    const [exportObserverActivityHistory] = useExportObserverActivityHistoryMutation()
    const dispatch = useDispatch()
    const [suggestions, setSuggestions] = useState("")
    const [skip, setSkip] = useState(true)
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams({ 'filter': 'true' });
    const viewId = useSelector((state) => state.systemConfigData.viewToHistory)
    const [isColumnSelect, setIsColumnSelect] = useState(false)
    const { data, isFetching, isLoading, isError, status, isSuccess } = useObserverActivityHistoryListQuery(searchParams?.toString(), { skip: skip, refetchOnMountOrArgChange: true })
    const initialState = {
        "filter_start_date": '',
        "filter_end_date": '',
    }
    const [filterValues, setFilterValues] = useState(initialState)
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsorg, setQueryParamsorg] = useState('')
    const userType = sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideOrganizationQuery(queryParamsorg, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });

    /**
     * The function `handleSearchParams` updates the search parameters by setting the value of a
     * specific key and value, and then updating the search parameters state.
     */
    const handleSearchParams = (key, value) => {
        let params = Object.fromEntries(searchParams);
        params.page_number = 1
        if (key === 'search') { params[key] = encodeURIComponent(value); }
        else params[key] = value
        if (params.search === '') delete params.search
        setSearchParams({ ...params })
    }

    useEffect(() => {
        if (Array.isArray(location.state) && location.state.length === 3) {
            if (location.state[1]) {
                dispatch(handleIsViewScreen([location.state[2]]))
            }
        }
        if (!searchParams.get('limit')) {
            handleSearchParams('limit', '15')
        }
        if (!searchParams.get('page_number')) {
            handleSearchParams('page_number', `1`)
        }
        if (!searchParams.get('user_name') && location.state !== null) {
            handleSearchParams('target_user_name', location.state[0])

        }


        setSuggestions(!searchParams.get('search') ? '' : decodeURIComponent(searchParams.get('search')) || '')

    }, [location]);
    useEffect(() => {

        if (searchParams.size >= 4) {
            setSkip(false)
        }

        else {
            setSkip(true)
        }
        if (searchParams.get("field") === null && searchParams.get("action") === null && searchParams.get("start_date") === null && searchParams.get("end_date") === null) {
            dispatch(resetFilterState())
        }
    }, [searchParams])
    useEffect(() => {
        if (userType === 'admin') {
            setQueryParamsorg('type=org-activity-logs');
        } else {
            setQueryParamsorg('type=org-user-activity-logs');
        }
    }, [userType]);
      
    useEffect(() => {
        if (queryParamsorg) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsorg]);


    function handleNoOfRowsClick(number) {
        // setLoading(true);
        let params = Object.fromEntries(searchParams);
        params.page_number = 1;
        params["limit"] = number;
        setSearchParams({ ...params });
    }
    const handleOnClickPageNumber = (pageNum) => {
        // setLoading(true);
        const params = Object.fromEntries(searchParams)
        setSearchParams({ ...params, page_number: pageNum })
        // dispatch(addToTopCheckbox([pageNum.selected+1,searchParams.get("limit")]))
    }
    const handleChange = (val) => {
        handleSearchParams('search', val)

    };
    const optimizedFn = useCallback(
        Debounce((value) => handleChange(value)),
        [searchParams]
    );
    const handleApplyFilter = (type) => {
        const fieldsToMatch = {
            "Email Address": "email_address",
            "Mobile Number": "mobile_number",
            "Main Number": "main_number",
            "County Code": "country_code",
            'User Type': 'user_type',
            'User ID': 'user_id',
            'Status': 'Status',

        }[filterValues.column_field]

        const actionsToMatch = {
            'Created': 'Created',
            'Deleted': 'Deleted',
            'Updated': 'Updated',
            'Activated': 'Activated',
            'Deactivated': 'Deactivated',
            'View': 'View'

        }[filterValues.action_performed]
        let params = Object.fromEntries(searchParams);
        const start_date = moment(filterValues.filter_start_date).format('YYYY-MM-DD')
        const end_date = moment(filterValues.filter_end_date).format('YYYY-MM-DD')
        dispatch(handleAddFilterValues({
            "filter_start_date": filterValues.filter_start_date,
            "filter_end_date": filterValues.filter_end_date,

        }))
        if (type) {
            params.page_number = 1
            filterValues.filter_start_date !== "" ? params["start_date"] = Math.floor(Date.parse(start_date) / 86400000) * 86400 : ''
            filterValues.filter_end_date !== "" ? params["end_date"] = Math.floor(Date.parse(end_date) / 86400000) * 86400 + 86399 : ''
            setSearchParams({ ...params })
        }
        else {
            params.start_date && delete params.start_date
            params.end_date && delete params.end_date
            setSearchParams({ ...params })
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await dataService.GetAPI(`system-configuration/`);
                dispatch(handleSystemConfig(response.data.data))
            } catch (error) {
                console.error("Error fetching data:", error);
            } 
        };
        fetchData();
    }, []);


    return (
        <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
            <TopHeader title={"Activity Log"} />
            <div className='bg-white rounded-lg py-3 h-customh3 relative'>
                <div className="px-6">
                    <div className='flex items-center mb-3.5'>
                        <Link to="/manage-observer">
                            <h1 className="text-sm font-normal text-[#52555D]">List of Observers</h1>
                        </Link>
                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>

                        <Link to={`/manage-observer/${viewId}`}>
                            <h1 className="text-sm font-normal text-[#52555D]">View Observer</h1>
                        </Link>
                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>
                        <div>
                            <h1 className="text-sm font-normal text-[#008586]">Activity Log</h1>
                        </div>
                        <span   onClick={() => setHelpGuideModel(true)} className=' ml-auto cursor-pointer'>
                            <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                        </span> 
                    </div>
                    <ObserverActivityHistoryTopBar
                        path={(data?.data?.length === 0 || data === undefined) ? "" : viewId !== "" && suggestions.trim() === '' ? `/manage-observer/${viewId}` : suggestions.trim() === '' ? '/manage-observer/' : '/manage-observer/activity_history'}
                        pathPlaceholder={'Go back to View Observer'}
                        SearchInput={((data?.data?.length === 0 && suggestions === "") || data === undefined) ? false : true}
                        ApplyFilter={(searchParams.get("start_date") === null && searchParams.get("end_date") === null && (data?.data?.length === 0 || data === undefined)) ? false : true}
                        suggestions={suggestions}
                        setSuggestions={setSuggestions}
                        handleApplyFilter={handleApplyFilter}
                        optimizedFn={optimizedFn}
                        data={data}
                        exportCols={['Username', 'Timestamp', 'Action Performed', 'Field', 'Old Value', 'New Value', 'Comments']}
                        filterValues={filterValues}
                        setFilterValues={setFilterValues}
                        isColumnSelect={isColumnSelect}
                        setIsColumnSelect={setIsColumnSelect}
                        initialState={initialState}
                        username={searchParams.get("target_user_name")}
                        exportObservers={exportObserverActivityHistory}
                        isIdexport={true}
                    />
                </div>
                {((isFetching && status !== "fulfilled" && status !== "rejected") || (data === undefined && status !== "fulfilled" && status !== "rejected")) ? <CustomOverLay Active text="Loading Activity Logs..." classKey={`absolute top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center  ${isSideBar ? 'opened_sidebar_overlay1' : 'overlay-list1'}`} /> : (data !== undefined && data?.data?.length > 0) ? <>
                    <div className="px-6">
                        <ObserverActivityTable
                            pageNumber={Number(searchParams.get('page_number')) || 1}
                            List={data}
                            handleSearchParams={handleSearchParams}
                        />
                    </div>
                    {data?.total_count >= 15 && <div className="w-full px-2.5 pt-1 flex items-center bg-[#F4F7FC] justify-between rounded-b-lg">
                        <p className="text-sm font-semibold text-[#687182]">Total Number of Records:{Math.ceil(parseInt(data?.total_count))}</p>
                        <div className="flex items-center">
                            <Limit
                                limit={limit}
                                setLimit={setLimit}
                                handleNoOfRowsClick={handleNoOfRowsClick} IsColumnSelect
                                isColumnSelect={isColumnSelect}
                            />
                            <Pagination
                                TotalCount={parseInt(data?.total_count)}
                                totalPageNumber={Math.ceil(parseInt(data?.total_count) / parseInt(searchParams?.get("limit")))}
                                handleOnClickPageNumber={handleOnClickPageNumber}
                                // limit={Number(searchParams.get('limit'))}
                                limit={parseInt(limit)}
                            />
                        </div>
                    </div>}
                </> : <>
                    {data?.data?.length === 0 && (suggestions !== "" || searchParams.get("field") !== null || searchParams.get("action") !== null || searchParams.get("start_date") !== null || searchParams.get("end_date") !== null) ?
                        <SearchEmptyScreen text={"That filter combination has no result. Please try different criteria"} setSkip={setSkip} />
                        :
                        status === "rejected" && <SearchEmptyScreen text={"No data found"} />
                    }
                </>}

            </div>
            {(helpGuideModel && helpguidestatus==="fulfilled") &&
            <HelpGuideModal
                setHelpGuideModel={setHelpGuideModel}
                pdfUrl={helpguidedata} // Pass the PDF URL to the modal
            />
            }
        </div>
    )
}
